import { Youtube, Instagram } from "lucide-react"
import logo from "../../asset/logo_white.png"
import { useNavigate, useLocation } from "react-router-dom"

export default function Footter() {
    const navigate = useNavigate()

  return (
    <div className="bg-[#0A476C] text-white">
      <div className="px-6 py-6 md:px-12 md:py-8 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="flex items-center gap-4">
                       <div className="flex items-center space-x-3">
            <img src={logo} alt="" className="w-30 h-10" />
           </div>
          </div>

          <div className="flex-1 lg:max-w-md lg:mx-8">
<p className="text-white font-inter text-[16px] font-normal leading-normal">
  Being in a motor vehicle accident can be life-changing. But you don’t have to go through it alone. Our team is committed to fighting for your rights and securing the settlement you need to move forward.
</p>
          </div>
<div className="flex flex-col items-center gap-4">
  {/* CTA Button */}
  <button
    onClick={() => navigate("/ContactUs")}
    className="rounded-2xl px-8 py-4 text-lg font-semibold 
               bg-[#0A476C] border-2 border-[#FC821F] text-[#FC821F] 
               hover:bg-[#FC821F] hover:text-white 
               transition-colors duration-200"
  >
    Start Your Claim
  </button>

  {/* Links */}
  <div className="flex gap-6 text-sm">
    <a
      href="#"
      className="text-white  transition-colors duration-200 no-underline"
    >
      Terms & Conditions
    </a>
    <a
      href="#"
      className="text-white  transition-colors duration-200 no-underline"
    >
      Privacy Policy
    </a>
  </div>
</div>

        </div>
      </div>

      <div className="border-t border-white/20 mx-6 md:mx-12 lg:mx-16"></div>


    </div>
  )
}
